import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteManSelection, deletePartEff, getAircrafts, getManualSelection, getPartEff, getRangeSelection, saveEffManSelection, saveEffRanges, savePartEffReq } from "../../../../modules/ConfigurationModule/services/EngineeringService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import { getDropdownData } from "../../../../services/dropdownsConfigService";


/**
 * Eff List => [
 *      {
            "version": 0,
            "id": 0,
            "partId": 0,
            "aircraftTypeId": 0,
            "companyId": 0,
            "selectionType": "string",
            "rangeType": "string",
            "status": "string",

            // 

            tempId: string
            acListByTail: [],
            acListBySerial: [],
            acListByLine:[],
            selection: []

        }
 * ]
 */

const defaultEff = (partId) => ({
    tempId: crypto.randomUUID(),
    id: null,
    version: 0,
    partId: partId,
    aircraftTypeId: null,
    companyId: parseInt(localStorage.getItem('u_company_id')),
    selectionType: "M",
    rangeType: "tail",
    status: "",
    acListByTail: [],
    acListBySerial: [],
    acListByLine: [],
    selection: [],
    aircraftName: "",
    isNew: true,
    manSelection: []
})

const listByType = {
    "tail": "acListByTail",
    "serial": "acListBySerial",
    "line": "acListByLine"
}

const typeRange = {
    "tail": "string",
    "serial": "number",
    "line": "number"
}

const parseValue = {
    "tail": x => x,
    "serial": x => parseInt(x),
    "line": x => parseInt(x)
}

const defaultRange = () => ({
    from: "",
    to: "",
    tempId: crypto.randomUUID()
})

export const effectivitySlice = createSlice({
    name: "effectivity",
    initialState: {
        effList: [],
        tempIdxEff: {},
        editing: {},
        ranges: {}
    },
    reducers: {
        resetEffState: (state, action) => {
            return {
                effList: [],
                tempIdxEff: {},
                editing: {},
                ranges: {}
            };
        },
        startEdition: (state, action) => {
            let { effTempId } = action.payload;
            return {
                ...state,
                editing: {
                    ...state.editing,
                    [effTempId]: true
                }
            }

        },
        removeRange: (state, action) => {
            let { effTempId, rangeTempId } = action.payload;
            return {
                ...state,
                ranges: {
                    ...state.ranges,
                    [effTempId]: state.ranges[effTempId].filter(i => !(i.tempId === rangeTempId))
                }
            }

        },
        applyRanges: (state, action) => {
            let { effTempId } = action.payload;
            let eff = { ...state.tempIdxEff[effTempId] };
            let selectionType = eff.selectionType;
            if (selectionType === "M") {
                return { ...state }
            }
            let ids = filterByRanges(eff[listByType[eff.rangeType ?? "line"]], `${eff.rangeType}_number`, state.ranges[effTempId], typeRange[eff.rangeType]).map(x => x.id);
            let [lineCopy, serialCopy, tailCopy] = [[...eff.acListByLine], [...eff.acListBySerial], [...eff.acListByTail]].map(list => list.map(i => ids.includes(i.id) ? ({ ...i, selected: true }) : ({ ...i, selected: false })));
            return {
                ...state,
                tempIdxEff: {
                    ...state.tempIdxEff,
                    [effTempId]: {
                        ...state.tempIdxEff[effTempId],
                        acListByLine: lineCopy,
                        acListBySerial: serialCopy,
                        acListByTail: tailCopy

                    }
                }
            }

        },
        updateRange: (state, action) => {
            let { effTempId, rangeIdx, name, value } = action.payload;
            let { rangeType } = state.tempIdxEff[effTempId];
            let copy = [...(state.ranges[effTempId]) ?? []];
            copy[rangeIdx] = { ...copy[rangeIdx], [name]: value };
            copy[rangeIdx] = { ...copy[rangeIdx], error: (Boolean(copy[rangeIdx].from) && Boolean(copy[rangeIdx].to)) && (parseValue[rangeType](copy[rangeIdx].from) > parseValue[rangeType](copy[rangeIdx].to)) ? "Lower limit cannot exceed upper limit" : "" };


            // if (copy[rangeIdx].from?.length > 0 && copy[rangeIdx].to?.length > 0) {
            //     let rangeType = state.tempIdxEff[effTempId].rangeType;
            //     let ids = getElementsBetween(state.tempIdxEff[effTempId][listByType[rangeType]], `${rangeType}_number`, copy[rangeIdx].from, copy[rangeIdx].to).map(a => a.id);
            //     let { acListByLine, acListBySerial, acListByTail } = state.tempIdxEff[effTempId];
            //     let lineCopy = acListByLine.map(ac => (ids.includes(ac.id))? ({ ...ac, selected:true }) : ac);
            //     let serialCopy = acListBySerial.map(ac => (ids.includes(ac.id))? ({ ...ac, selected:true }) : ac);
            //     let tailCopy = acListByTail.map(ac => (ids.includes(ac.id))? ({ ...ac, selected:true }) : ac);
            //     return {
            //         ...state,
            //         ranges: { 
            //             ...state.ranges, 
            //             [effTempId]: copy,

            //         },
            //         tempIdxEff: {
            //             ...state.tempIdxEff,
            //             [effTempId]: {
            //                 ...state.tempIdxEff[effTempId],
            //                 acListByTail: tailCopy,
            //                 acListByLine: lineCopy,
            //                 acListBySerial: serialCopy
            //             }
            //         }
            //     }

            // }
            return {
                ...state,
                ranges: { ...state.ranges, [effTempId]: copy }
            }
        },
        addEffectivity: (state, action) => {
            let { partId } = action.payload;
            let newEff = defaultEff(partId);
            return { ...state, editing: { ...state.editing, [newEff.tempId]: true }, effList: [newEff, ...state.effList], tempIdxEff: { ...state.tempIdxEff, [newEff.tempId]: newEff } }
        },
        updateEffectivity: (state, action) => {
            let { name, value, effTempId, obj } = action.payload;
            let copy = { ...state.tempIdxEff[effTempId], [name]: value }


            switch (name) {
                case "aircraftTypeId":
                    copy.aircraftName = obj.name
                    break;
            }
            return {
                ...state,
                tempIdxEff: {
                    ...state.tempIdxEff,
                    [effTempId]: { ...copy }
                }
            }
        },
        selectAll: (state, action) => {
            let { effTempId, checked } = action.payload;
            let { acListByLine, acListBySerial, acListByTail } = state.tempIdxEff[effTempId];
            let lineCopy = acListByLine.map( ac => ({ ...ac, selected: checked}) );
            let serialCopy = acListBySerial.map(ac => ({ ...ac, selected:checked }) );
            let tailCopy = acListByTail.map(ac => ({ ...ac, selected:checked }) );
            return {
                ...state,
                tempIdxEff: {
                    ...state.tempIdxEff,
                    [effTempId]: {
                        ...state.tempIdxEff[effTempId],
                        acListByTail: tailCopy,
                        acListByLine: lineCopy,
                        acListBySerial: serialCopy
                    }
                }
            }


        },
        udpateAcSelection: (state, action) => {
            let { selected, acId, effTempId } = action.payload;
            let { acListByLine, acListBySerial, acListByTail } = state.tempIdxEff[effTempId];
            let lineCopy = acListByLine.map( ac => ac.id === acId ? ({ ...ac, selected }) : ac);
            let serialCopy = acListBySerial.map(ac => ac.id === acId ? ({ ...ac, selected }) : ac);
            let tailCopy = acListByTail.map(ac => ac.id === acId ? ({ ...ac, selected }) : ac);
            


            return {
                ...state,
                tempIdxEff: {
                    ...state.tempIdxEff,
                    [effTempId]: {
                        ...state.tempIdxEff[effTempId],
                        acListByTail: tailCopy,
                        acListByLine: lineCopy,
                        acListBySerial: serialCopy
                    }
                }
            }
        },
        addRange: (state, action) => {
            let { effTempId } = action.payload;
            return {
                ...state,
                ranges: {
                    ...state.ranges,
                    [effTempId]: [...(state.ranges[effTempId] ?? []), defaultRange()]
                }
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPartEff.fulfilled, (state, action) => {
            let load = action.payload;

            return { ...state, effList: load, tempIdxEff: Object.fromEntries(load.map(l => ({ ...l, tempId: crypto.randomUUID(), acListByLine: [], acListBySerial: [], acListByTail: [], manSelection: [], rangeType: l.rangeType || "tail" }))) };
        });
        builder.addCase(fetchAircrafts.fulfilled, (state, action) => {
            let { load, effTempId } = action.payload;

            return {
                ...state,
                tempIdxEff: {
                    ...state.tempIdxEff,
                    [effTempId]: {
                        ...state.tempIdxEff[effTempId],
                        acListByTail: sortAlphabetically(load, "tail_number"),
                        acListByLine: sortWithNumericFallback(load, "line_number"),
                        acListBySerial: sortWithNumericFallback(load, "serial_number")
                    }
                }
            }
        });
        builder.addCase(saveEffectivity.fulfilled, (state, action) => {
            let { effResp, selectionType, manSelection, ranges, effTempId, eff, closeEdition } = action.payload;
            if (eff) {
                if (selectionType === "M") {

                    return {
                        ...state,
                        tempIdxEff: {
                            ...state.tempIdxEff,
                            [effTempId]: { ...eff, manSelection }
                        },
                        editing: {
                            ...state.editing,
                            [effTempId]: closeEdition ? false : state.editing[effTempId]
                        }
                    }

                } else {
                    return {
                        ...state,
                        tempIdxEff: {
                            ...state.tempIdxEff,
                            [effTempId]: { ...eff }
                        },
                        editing: {
                            ...state.editing,
                            [effTempId]: closeEdition ? false : state.editing[effTempId]
                        },
                        ranges: {
                            ...state.ranges,
                            [effTempId]: ranges.map(r => ({ ...r, tempId: crypto.randomUUID(), from: r.aircraftIdFrom, to: r.aircraftIdTo }))
                        }
                    }
                }

            } else {
            }
        });
        builder.addCase(fetchEffectivities.fulfilled, (state, action) => {
            let { load } = action.payload;
            load = load.map(l => ({ ...l, acListByLine: [], acListBySerial: [], acListByTail: [], manSelection: [], rangeType: l.rangeType || "tail" }))
            return {
                ...state,
                effList: load,
                tempIdxEff: Object.fromEntries(load.map(l => [l.tempId, l]))

            }
        });
        builder.addCase(deleteEff.fulfilled, (state, action) => {
            let { effTempId } = action.payload;
            return {
                ...state,
                effList: state.effList.filter(eff => !(eff.tempId === effTempId))
            }
        });
        builder.addCase(fetchAcSelection.fulfilled, (state, action) => {
            let { load, effTempId, selectionType, rangeType } = action.payload;
            let eff = state.tempIdxEff[effTempId];
            let acIds = selectionType === "M" ?
                load.map(ac => ac.aircraftId) :
                filterByRanges(eff[listByType[eff.rangeType ?? "line"]], `${eff.rangeType}_number`, load.map(r => ({ ...r, from: r.aircraftIdFrom, to: r.aircraftIdTo })), typeRange[eff.rangeType]).map(x => x.id);
            ;
            let { acListByLine, acListBySerial, acListByTail } = state.tempIdxEff[effTempId];
            let lineCopy = acListByLine.map(ac => ({ ...ac, selected: acIds.includes(ac.id) ? true : false }));
            let serialCopy = acListBySerial.map(ac => ({ ...ac, selected: acIds.includes(ac.id) ? true : false }));
            let tailCopy = acListByTail.map(ac => ({ ...ac, selected: acIds.includes(ac.id) ? true : false }));
            return {
                ...state,
                tempIdxEff: {
                    ...state.tempIdxEff,
                    [effTempId]: {
                        ...state.tempIdxEff[effTempId],
                        acListByTail: tailCopy,
                        acListByLine: lineCopy,
                        acListBySerial: serialCopy,
                        manSelection: selectionType === "M" ? load: (state.tempIdxEff[effTempId].manSelection ?? [])
                    }
                },
                ranges: {
                    ...state.ranges,
                    [effTempId]: selectionType === "M" ? [...(state.ranges[effTempId] ?? [])] : load.map(r => ({ ...r, tempId: crypto.randomUUID(), from: r.aircraftIdFrom, to: r.aircraftIdTo }))
                }
            }
        })

    }

});

export const fetchPartEff = createAsyncThunk("effectivity/getPartEff",
    async ({ partId }, { rejectWithValue, getState }) => {
        let response = await getPartEff(partId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return response.data.load
        } else {
            return rejectWithValue(response.data);
        }
    }
)


export const fetchAircrafts = createAsyncThunk("effectivity/fetchAircrafts",
    async ({ fleetId, effTempId }, { rejectWithValue, getState }) => {
        let response = await getAircrafts(fleetId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { load: response.data.load, effTempId };
        } else {
            return rejectWithValue(null);
        }
    }
)


export const fetchAcSelection = createAsyncThunk("effectivity/fetchAcSelection",
    async ({ effTempId }, { rejectWithValue, getState }) => {
        let eff = getState().effectivity.tempIdxEff[effTempId];
        if (typeof (eff.id) === 'number') {
            if (eff.selectionType === "M") {

                let response = await getManualSelection(eff.id);
                if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                    return { response, load: response.data.load, effTempId, selectionType: eff.selectionType };
                } else {
                    return rejectWithValue(response);
                }
            } else {
                let response = await getRangeSelection(eff.id);
                if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                    return { response, load: response.data.load, effTempId, selectionType: eff.selectionType, rangeType: eff.rangeType };
                } else {
                    return rejectWithValue({ response });
                }

            }
        }
        else {
            return rejectWithValue(null);
        }
    }
)

let defManItem = {
    version: 0,
    id: null,
    partEffectivityId: null,
    aircraftId: null
}

export const deleteEff = createAsyncThunk("effectivity/deleteEffectivity",
    async ({ effTempId }, { rejectWithValue, getState }) => {
        let eff = getState().effectivity.tempIdxEff[effTempId]
        let response = await deletePartEff(eff.id);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.DELETED) {
            return { success: true, response, effTempId };
        } else {
            return rejectWithValue({ success: false, response })
        }
    }
);

export const saveEffectivity = createAsyncThunk("effectivity/saveEffectivity",
    async ({ effTempId, closeEdition }, { rejectWithValue, getState }) => {
        let { tempIdxEff, ranges } = getState().effectivity;
        let eff = tempIdxEff[effTempId];
        let effRanges = ranges;
        let manSelection = eff.manSelection;
        let response = await savePartEffReq(eff);
        if ([HTTP_RESPONSE_CODES.CREATED, HTTP_RESPONSE_CODES.UPDATED].includes(response.data.responseCode)) {
            let updtEff = response.data.load;
            if (eff.selectionType === "M") {
                let selectedAc = eff.acListByTail.filter(i => i.selected);
                let updtManSel = selectedAc.map((ac, j) => ({ ...(manSelection[j], { ...defManItem }), partEffectivityId: updtEff.id, aircraftId: ac.id }))
                let deleteManSel = selectedAc.length < manSelection.length ? manSelection.slice(-(manSelection.length - selectedAc.length)) : []
                let respManSelection = await saveEffManSelection(updtManSel);
                if (respManSelection.data.responseCode = HTTP_RESPONSE_CODES.UPDATED) {
                    if (deleteManSel.length > 0) {
                        let respManDelete = await Promise.all(deleteManSel.map(dItem => deleteManSelection(dItem.id)));
                        if (respManDelete.every(r => r.data.responseCode === HTTP_RESPONSE_CODES.UPDATED)) {
                            return { effResp: response, selectionType: eff.selectionType, manSelection: respManSelection.data.load, effTempId, eff: { ...eff, ...updtEff }, closeEdition }
                        } else {
                            return rejectWithValue(null)
                        }
                    } else {
                        return { effResp: response, selectionType: eff.selectionType, manSelection: respManSelection.data.load, effTempId, eff: { ...eff, ...updtEff }, closeEdition }
                    }
                } else {
                    // TODO: Collect errors;
                    return rejectWithValue(null);
                }
            } else {
                let rangesToSave = effRanges[effTempId];
                if (rangesToSave.length > 0) {
                    let respRanges = await saveEffRanges(rangesToSave.map(r => ({ ...r, partEffectivityId: updtEff.id, aircraftIdFrom: r.from, aircraftIdTo: r.to })))
                    if (respRanges.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
                        return { effResp: response, selectionType: eff.selectionType, ranges: respRanges.data.load, effTempId, closeEdition, eff: { ...eff, ...updtEff } }
                    } else {
                        // TODO: Collect errors;
                        return rejectWithValue(null);
                    }
                    // let responses = await Promise.all(ranges.map(r => saveEffRanges({...r, partEffectivityId:updtEff.id, aircraftIdFrom: r.from, aircraftIdTo:r.to})));

                } else {
                    return { effResp: response, selectionType: eff.selectionType, effTempId, manSelection: [], effTempId, eff: { ...eff, ...updtEff }, closeEdition }

                }
            }
        } else {
            return rejectWithValue(response);
        }

        // if selectionType is M, call delete service on all ranges

        // if selectionType is R call delete serviece on all selections

        //     let response = await savePartEff
        // 
    }
)

export const fetchEffectivities = createAsyncThunk("effectivity/fetchEffectivites",
    async ({ partId }, { getState, rejectWithValue }) => {
        let response = await getPartEff(partId);
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            return { load: response.data.load.map(i => ({ ...i, tempId: crypto.randomUUID() })) };
        } else {
            return rejectWithValue(null)
        }
    }
)

function filterByRanges(array, property, ranges, type) {
    return array.filter(element => {
        let value = element[property];

        return ranges?.some(({ from, to }) => {
            if (type === 'number') {
                value = parseInt(value);
                return value >= parseInt(from) && value <= parseInt(to);
            } else if (type === 'string') {
                return value.localeCompare(from) >= 0 && value.localeCompare(to) <= 0;
            }
            return false; // Default case if type is invalid
        });
    });
}


export const {selectAll, addEffectivity, updateEffectivity, udpateAcSelection, startEdition, addRange, updateRange, applyRanges, removeRange, resetEffState } = effectivitySlice.actions;
export const selectEffList = (state) => state.effectivity.effList;
export const selectAircrafts = (state, effTempId) => state.effectivity.tempIdxEff[effTempId].acListByTail;
export const selectACLine = (state, effTempId) => state.effectivity.tempIdxEff[effTempId].acListByLine;
export const selectACSerial = (state, effTempId) => state.effectivity.tempIdxEff[effTempId].acListBySerial;
export const selectEff = (state, effTempId) => state.effectivity.tempIdxEff[effTempId];
export const selectEditingEff = (state, effTempId) => state.effectivity.editing[effTempId];
export const selectRanges = (state, effTempId) => state.effectivity.ranges[effTempId];
export const selectGeneralRanges = (state) => state.effectivity.ranges;
export default effectivitySlice.reducer;

function sortAlphabetically(arr, prop) {
    return arr.toSorted((a, b) => a[prop].localeCompare(b[prop], undefined, { sensitivity: "base" }));
}

function sortWithNumericFallback(arr, prop) {
    return arr.toSorted((a, b) => {
        const numA = parseFloat(a[prop]); // Handles both integers and decimals
        const numB = parseFloat(b[prop]);

        // Check if both values are valid numbers
        if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB; // Numeric sorting
        }

        // Alphabetical sorting if either value isn't a number
        return a[prop].localeCompare(b[prop], undefined, { sensitivity: "base" });
    });
}

